/**
 * Header Animation Module
 * 
 * Simple scroll-based header behavior:
 * - Add 'hide-header' class when scrolling down
 * - Remove 'hide-header' class when scrolling up
 * - Logo stays white at all times (no swap on scroll)
 */

/**
 * Initialize header scroll behavior
 */
function initHeaderScrollBehavior() {
    const header = document.getElementById('masthead');

    if (!header) return;
    
    let lastScrollY = window.scrollY;
    
    function handleScroll() {
        const currentScrollY = window.scrollY;
        const scrollDirection = currentScrollY > lastScrollY ? 'down' : 'up';
        
        // Add hide-header class when scrolling down
        if (scrollDirection === 'down') {
            header.classList.add('hide-header');
            if (currentScrollY > 500) {
                header.classList.add('small-top-margin');
            }
        } 
        // Remove hide-header class when scrolling up
        else if (scrollDirection === 'up') {
            header.classList.remove('hide-header');
            if (currentScrollY === 0) {
                header.classList.remove('small-top-margin');
            }
        }
        
        lastScrollY = currentScrollY;
    }
    
    // Throttle scroll events for better performance
    let ticking = false;
    function requestTick() {
        if (!ticking) {
            requestAnimationFrame(handleScroll);
            ticking = true;
        }
    }
    
    function onScroll() {
        ticking = false;
        requestTick();
    }
    
    // Add scroll event listener
    window.addEventListener('scroll', onScroll, { passive: true });
    
    console.log('[SOJ] Header scroll behavior initialized');
}

// Export the function for use in other modules
export { initHeaderScrollBehavior };
